var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    { staticClass: "btn-content", attrs: { href: "tel:0033978978000" } },
    [
      _c("svgicon", {
        attrs: { name: "phone", color: "#FFFFFF", width: "18", height: "18" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }